import httpClient from "./httpClient";
import qs from "qs";
import type { ApiResponse } from "../types/api";

export default class ModuleApi {
  static getAll(language: string | null = null): Promise<ApiResponse> {
    return httpClient
      .get(API_URL + "/module", {
        params: language ? { lang: language } : {},
        paramsSerializer: (params: Record<string, unknown>) => qs.stringify(params),
      })
      .then((response) => response.data);
  }
}
